import React from 'react';
import { Link } from 'react-router-dom';
import LocalizationManager from '../../../utils/localization/localization';

const ModernFooter = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { label: LocalizationManager.t('aboutUs'), id: 'about' },
    { label: LocalizationManager.t('solutions'), id: 'services' },
    { label: LocalizationManager.t('technologies'), id: 'technologies' },
    { label: LocalizationManager.t('team'), id: 'team' }
  ];

  const socialLinks = [
    { abbr: 'f', name: 'Facebook', url: 'https://www.facebook.com/gdlestore' },
    { abbr: 'x', name: 'Twitter', url: 'https://www.twitter.com/gdlestore' },
    { abbr: 'in', name: 'Instagram', url: 'https://www.instagram.com/gdlestore' },
    { abbr: 'gh', name: 'GitHub', url: 'https://github.com/gdlestore' }
  ];

  return (
    <footer className="relative bg-dark-900 border-t border-white border-opacity-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-4 flex items-center gap-3">
              <img
                src="/images/logo-white.svg"
                alt="Logo"
                className="w-10 h-10"
              />
              <h3 className="text-2xl font-bold text-white">{LocalizationManager.t('brand')}</h3>
            </div>
            <p className="text-dark-300 mb-6">
              {LocalizationManager.t('footerSubtitle')}
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 glass rounded-full flex items-center justify-center text-white text-xs font-bold hover:backdrop-blur-2xl hover:bg-white hover:bg-opacity-20 transition-all duration-300"
                  title={social.name}
                >
                  {social.abbr}
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">{LocalizationManager.t('footerNavigation')}</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-dark-300 hover:text-white transition-colors duration-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">{LocalizationManager.t('footerServices')}</h4>
            <ul className="space-y-3">
              {[
                { key: 'footerB2BText', name: 'b2b' },
                { key: 'footerB2CText', name: 'b2c' },
                { key: 'footerFullStackText', name: 'fullstack' }
              ].map((service) => (
                <li key={service.name}>
                  <a
                    href="#services"
                    className="text-dark-300 hover:text-white transition-colors duration-300"
                  >
                    {LocalizationManager.t(service.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">
              {LocalizationManager.t('footerContactTitle')}
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:info@gdlestore.com"
                  className="text-dark-300 hover:text-white transition-colors duration-300"
                >
                  info@gdlestore.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+523321814488"
                  className="text-dark-300 hover:text-white transition-colors duration-300"
                >
                  +52 332 181 4488
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/523321814488"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark-300 hover:text-white transition-colors duration-300"
                >
                  WhatsApp: +52 332 181 4488
                </a>
              </li>
            </ul>
            <Link
              to="/contactUs"
              className="mt-6 inline-block px-6 py-3 rounded-lg font-semibold text-white bg-gradient-to-r from-purple-600 to-pink-600 hover:shadow-lg hover:shadow-purple-500/50 transition-all duration-300"
            >
              {LocalizationManager.t('contactGetInTouch')}
            </Link>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white border-opacity-10 my-8"></div>

        {/* Bottom section */}
        <div className="flex flex-col md:flex-row justify-between items-center text-dark-400 text-sm">
          <p>
            © {currentYear} {LocalizationManager.t('brand')}.{' '}
            {LocalizationManager.t('reservedRights')}
          </p>
          <div className="flex gap-6 mt-6 md:mt-0">
            <a href="#" className="hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Cookies
            </a>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 right-0 w-96 h-96 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl opacity-5"></div>
      </div>
    </footer>
  );
};

export default ModernFooter;
